import { useMatches, useNavigate, useParams } from 'react-router-dom'
import { useAuth, useGuard } from '../../hooks/auth'
import { LOCAL_EXECUTION } from '../../utils/featureFlag'
import {
  Container,
  RegistrationBox,
  OwnerBox,
  StyledForm,
  BankBox,
  AgencyBox,
  AccountIdentifierBox,
  AccountNumberBox,
  FormDivider,
  PageSubtitle,
  PageTitle,
  TextHeaderBox,
  DigitBox,
  ExceptionContainer,
  SelectedAccountBox,
  SelectedAccountField,
  SelectedAccountInfo,
  InfoDivider,
  StepInfo,
  AvaliableMoneyBox,
  AddAccountBox,
  AddAccountIconBox,
  AddAccountTextBox,
  AddAccountTitle,
  AddAccountSub,
  StepTitleText,
  TermsAndConditionInput,
  TermsAndConditionLabel,
  TermsAndConditionLink,
  TermsAndConditionTextBox,
  TermsAndConditionText,
  AvaliableInputBox,
  FirstStepButtonBox,
  AddAccountArrowBox,
  ReasonAndDescriptionBox,
  DescriptionBox,
  SelectedAccountInfoBox,
  GridForm,
  AccountTypeBox,
  GoAHeadButtonBox,
  ReturnButtonBox,
  ButtonsGridBox,
  IconPixContainer,
  PixIcon,
  AddPixAccountBox,
  TransactionTypeBox,
  HorizontalContainer,
  RegistrationPixBox,
  OwnerPixBox,
  PixTypeKeyBox,
  PixKeyBox,
} from './styles'
import {
  DashboardAccountPicker,
  DashboardhMediumButton,
  DashboardStepCount,
  Icon,
  DashboardBLRInput,
} from 'bd-web-components'
// @ts-ignore
import { useFormik } from 'formik'
import { createBankAccount } from '../../Service/accounts'
// @ts-ignore
import { toast } from 'react-toastify'
import { ReactElement, useEffect, useState } from 'react'
import { isLetter } from '../../utils/string-modeling'
import {
  descriptionAndTermsValidation,
  getValidationSchema,
} from '../../utils/yup-validation'
import { WithdrawFlowInitialValues } from '../../types/bank-account'
import Loader from '../../components/Loader'
import { getDashColor } from '../../styles'
import {
  GRAY_SCALE_09,
  PRIMARY_BLUE_03,
  SECONDARY_GREEN_01,
  SECONDARY_GREEN_07,
} from 'bd-web-components/src/utils/dash-colors'
import FormikField from '../../components/Field/index'
import {
  accountBaseData,
  transactionTypeOptions,
} from '../../utils/bank-account'
import * as Yup from 'yup'
//@ts-ignore
import currencyFormatter from 'currency-formatter'
import { ConfirmationModal } from '../../components/ConfirmationModal'
import { useBalanceDistribution } from '../../hooks/balance-distribution'
import {
  clearAccountsFieldsUntouched,
  formatCpfCnpj,
  getBankName,
  hasEmptyProperty,
  setAccountsFieldsUntouched,
  StepInfoData,
  formatReal,
  handlerSetBankAccount,
  cpfCNPJSanitazer,
  hasEmptyPixProperty,
} from '../../utils/withdraw-helpers'
import { useWithdraw } from '../../hooks/withdraw'
import { bankItemProps, useBankList } from '../../hooks/bank'
import { useUserBankAccounts } from '../../hooks/account'
import useSWRMutation from 'swr/mutation'
import {
  ConfirmationProps,
  SucessOrFailModal,
} from '../../components/SucessOrFailModal'
import { CustomModal } from '../../components/CustomModal'
import UseTerms from '../../components/UseTerm'
import { useEvent } from '../../hooks/events'
import { isAfter } from 'date-fns'
import { onlyCpjCNPJvalid } from '../../utils/onlyValidAccounts'
import { errorRedirect } from '../../utils/redirect'
import { EventDataNPS, NPSModal } from '../../components/NPSModal'
import { useBoolean } from '../../hooks/use-boolean'
import { useUser } from '../../hooks/auth'
import { useVerifyNps } from '../../hooks/verify-nps'
import pixIcon from '../../assets/pix-icon.svg'
import { pixKeyOptions } from '../../utils/pix-account'
import { CustomResumeModal } from '../../components/CustomResumeModal'
import { PixConfirmationModal } from '../../components/PixConfirmationModal'
import { TedConfirmationModal } from '../../components/TedConfirmationModal'
import { Breadcrumb } from '../../components/Breadcrumb'
import { ENABLE_NEW_TED_MODAL } from '../../config'

const confirmationSettedMsg: ConfirmationProps = {
  customSuccess: {
    title: 'Saque Solicitado com Sucesso!',
    subtitle: 'Agora é só aguardar!',
  },
  customError: {
    title: 'Erro ao Solicitar Saque!',
    subtitle: 'Tente novamente!',
  },
}

export function Withdraw(): ReactElement {
  window.document.title = 'Solicitar Saque'
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { mutate } = useUserBankAccounts()
  const authContext = useAuth()
  const { cookies, authHookWithEvent } = authContext

  // verify if user has this event
  if (!LOCAL_EXECUTION) {
    authHookWithEvent(id!, navigate)
  }

  // verify if user has permission to acess
  useGuard(['DP3', 'DP4', 'DP5'])

  // -----------------------------------------------------------------
  const [useAccountForm, setUseAccountForm] = useState<boolean>(false)
  const [saveAccount, setSaveAccount] = useState<boolean>(false)
  const [accounts, setAccounts] = useState<any[] | null>(null)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [pixAccounts, setPixAccounts] = useState<any[] | null>(null)
  const [selectedAccount, setSelectedAccount] = useState<number>(0)
  const [eventoData, setEventoData] = useState<EventDataNPS>({
    id: '',
    event_name: '',
    pracaId: '',
    praca: '',
  })

  const [HasNPS, setHasNPS] = useState<boolean>(false)
  const NPSService = 'Saque'
  const NPSLoading = useBoolean()
  const user = useUser()
  const { NPS } = useVerifyNps(user.id.toString())

  const useBankListObject = useBankList()
  const [bankList, setBankList] = useState<bankItemProps[]>([])
  const userAccountsObject = useUserBankAccounts()

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isOpenResumeModal, setIsOpenResumeModal] = useState<boolean>(false)
  const [isConfirmationOpen, setIsConfirmationOpen] = useState<boolean>(false)
  const [isTermModal, setIsTermModal] = useState<boolean>(false)
  const [isSuccess, setIsSuccess] = useState<boolean | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [withdrawLimit, setWithdrawLimit] = useState<number>(0)
  const [currentStep, setCurrentStep] = useState(1)
  const balanceDistribution = useBalanceDistribution(Number(id))
  const [confirmationMsg, setConfirmationMsg] = useState<ConfirmationProps>(
    confirmationSettedMsg
  )
  const eventData = useEvent(Number(id))
  const [isAfterEvent, setIsAfterEvent] = useState<any>(false)
  const [code2fa, setCode2fa] = useState<string>('')
  const [usePixForm, setUsePixForm] = useState<boolean>(false)
  const [isPixConfirmationModalOpen, setIsPixConfirmationModalOpen] =
    useState<boolean>(false)
  const [isTedConfirmationModalOpen, setIsTedConfirmationModalOpen] =
    useState<boolean>(false)

  let matches = useMatches()
  let crumbs = matches
    .filter((match: any) => Boolean(match.handle?.crumb))
    .map((match: any) => {
      return {
        name: match.handle.crumb(match.data),
        path: match.pathname,
      }
    })

  const withdrawMoneyFormatted = currencyFormatter.format(withdrawLimit, {
    code: 'BRL',
  })

  const authToken = LOCAL_EXECUTION
    ? process.env.REACT_APP_LOCAL_EXECUTION_TOKEN
    : cookies.userJWT

  const initial: WithdrawFlowInitialValues = {
    withdrawMoney: '',
    nationalRegistration: '',
    accountOwner: '',
    bank: '',
    agency: '',
    accountType: '',
    accountNumber: '',
    accountDigit: '',
    accountIdentifier: '',
    reason: '',
    description: '',
    transactionType: '',
    pixKey: '',
    pixTypeKey: '',
    termsAndConditions: false,
  }

  const minValues = {
    value: isAfterEvent ? 0.01 : 100,
    msg: isAfterEvent
      ? 'Valor mínimo para saque é de R$ 0,01'
      : 'Valor mínimo para saque é de R$ 100,00',
  }

  const useFormikProps = useFormik({
    initialValues: initial,
    validateOnBlur: false,
    validateOnMount: false,
    validationSchema: () => {
      if (currentStep === 1) {
        return Yup.object().shape({
          withdrawMoney: Yup.number()
            .typeError('Use apenas números ou vírgula')
            .required('Requerido - Use apenas números ou vírgula')
            .min(minValues.value, minValues.msg)
            .max(withdrawLimit, 'Valor deve ser menor que o saldo disponível'),
        })
      }
      if (currentStep === 2) {
        return getValidationSchema(usePixForm)
      }
      if (currentStep === 3) return descriptionAndTermsValidation
    },
    onSubmit: async (values: any, { setSubmitting, resetForm }: any) => {
      // CONTROL OF BLUE ON CHANGE VALIDATION FIELDS
      if (currentStep === 1) setAccountsFieldsUntouched(useFormikProps)
      if (currentStep === 2)
        useFormikProps.setFieldTouched('termsAndConditions', false)

      // HANDLER SAVE ACCOUNT
      if (currentStep === 2 && saveAccount) {
        values.accountDigit = isLetter(values.accountDigit)
        values.nationalRegistration = cpfCNPJSanitazer(
          values.nationalRegistration.toString()
        )
        setLoading(true)
        const createAccountRequest = await createBankAccount(authToken, values)
        if (createAccountRequest) {
          toast.success('Conta cadastrada com sucesso!')
          await mutate()
          setUseAccountForm(false)
          setUsePixForm(false)
          setSelectedAccount(0)
          setLoading(false)
        } else {
          toast.error('Um erro aconteceu, tente novamente')
          setLoading(false)
        }
        setSaveAccount(false)
      }

      if (currentStep < 3) {
        setCurrentStep((s) => s + 1)
      }
      if (currentStep === 3) {
        if (useFormikProps.values.transactionType === 'PIX') {
          setIsPixConfirmationModalOpen(true)
        } else if (
          useFormikProps.values.transactionType === 'TED' &&
          ENABLE_NEW_TED_MODAL
        ) {
          setIsTedConfirmationModalOpen(true)
        } else {
          setIsOpen(true)
        }
      }
    },
  })

  const handleAddBankAccount = () => {
    clearAccountsFieldsUntouched(useFormikProps)
    setAccountsFieldsUntouched(useFormikProps)
    setSelectedAccount(0)
    setAccounts(null)
    useFormikProps.setFieldValue('transactionType', 'TED')
    setUseAccountForm(true)
    setUsePixForm(false)
  }

  const handleAddPixAccount = () => {
    clearAccountsFieldsUntouched(useFormikProps)
    setAccountsFieldsUntouched(useFormikProps)
    setSelectedAccount(0)
    setAccounts(null)
    useFormikProps.setFieldValue('transactionType', 'PIX')
    setUseAccountForm(false)
    setUsePixForm(true)
  }

  const bankListWithNumberAndName = bankList.map((bank: any) => {
    return {
      id: bank.id,
      value: bank.value,
      label: `${bank.value} - ${bank.label}`,
    }
  })

  const handleBack = () => {
    setCurrentStep((prevStep) => prevStep - 1)
  }

  const handleAccountsBack = () => {
    setUseAccountForm(false)
    setUsePixForm(false)
    setCurrentStep((prevStep) => prevStep - 1)
  }

  // CONTROL BUTTON STATUS
  const hasBankAccount: any = hasEmptyProperty(useFormikProps.values)
  const hasBankPixAccount: any = hasEmptyPixProperty(useFormikProps.values)
  const hasValueOfMoney =
    useFormikProps.errors.withdrawMoney === undefined &&
    useFormikProps.values.withdrawMoney !== ''
  const hasTermsAndCondition =
    useFormikProps.errors.termsAndConditions === undefined &&
    useFormikProps.values.termsAndConditions !== false
  const rollBackUrl = `/events/${id}`

  const { useWithdrawFetcher } = useWithdraw(id, useFormikProps.values, code2fa)
  const { trigger: withdrawTrigger }: any = useSWRMutation(
    'useWithdrawSWR',
    useWithdrawFetcher,
    { revalidate: false }
  )

  useEffect(() => {
    if (userAccountsObject.accounts !== undefined) {
      const data = userAccountsObject.accounts.data.data
      if (data !== null) {
        if (data[0] !== undefined) {
          if (!useAccountForm) {
            setAccounts(data)
          }
        }
        if (data[0] === undefined) {
          setAccounts(null)
          setUseAccountForm(true)
        }
      }
    }
  }, [userAccountsObject, currentStep, useAccountForm])

  useEffect(() => {
    if (useBankListObject.bankList !== undefined) {
      const data = useBankListObject.bankList.data.data
      setBankList(data)
    }
  }, [useBankListObject])

  useEffect(() => {
    if (NPS !== undefined) {
      const data = NPS.data.data
      setHasNPS(data)
    }
  }, [NPS])

  useEffect(() => {
    if (balanceDistribution.balance !== undefined) {
      const data = balanceDistribution.balance.data.body.data
      const limit = data.reduce((acumulador: number, item: any) => {
        return acumulador + item.value
      }, 0)
      setWithdrawLimit(limit)
    }
    if (balanceDistribution.isError) {
      const data = balanceDistribution.isError.response?.data as {
        message: string
      }
      errorRedirect(
        '/error',
        {
          message: data?.message,
          tittle: 'Não permitido',
        },
        navigate
      )
    }
  }, [balanceDistribution, navigate])

  useEffect(() => {
    if (eventData.event !== undefined) {
      const data = eventData.event.data
      const now = new Date()
      const targetDate = new Date(data as any)
      setIsAfterEvent(isAfter(now, targetDate))
      setEventoData({
        event_name: eventData.event.nome,
        pracaId: eventData.event.pracaId!,
        praca: eventData.event.praca!,
      })
    }
  }, [
    eventData.event,
    eventData.events,
    eventData.isLoading,
    eventData.isError,
  ])

  const filteredAccounts = onlyCpjCNPJvalid(accounts)

  useEffect(() => {
    if (
      (currentStep === 2 && useAccountForm) ||
      (currentStep === 2 && usePixForm)
    ) {
      if (useFormikProps.values.transactionType === 'PIX') {
        setUsePixForm(true)
      } else {
        setUsePixForm(false)
      }
    }
  }, [
    currentStep,
    useAccountForm,
    usePixForm,
    useFormikProps.values.transactionType,
  ])

  const handleCustomResumeModalConfirm = () => {
    if (useFormikProps.values.transactionType) {
      setIsOpenResumeModal(false)
      useFormikProps.handleSubmit()
    }
  }

  return (
    <>
      <Container>
        <Breadcrumb paths={crumbs} />
        <TextHeaderBox>
          <PageTitle>{'Saque'}</PageTitle>
          <PageSubtitle>
            Esta tela destina-se à solicitação de saque. Prossiga seguindo as
            instruções abaixo para concluir o processo.
          </PageSubtitle>
        </TextHeaderBox>
        <FormDivider />
        {!balanceDistribution.isLoading && (
          <>
            <DashboardStepCount steps={currentStep} />
            <StepInfo>{StepInfoData(currentStep)}</StepInfo>
            <StyledForm onSubmit={useFormikProps.handleSubmit}>
              {/* STEP - VALOR DO SAQUE */}
              {currentStep === 1 && (
                <>
                  <div>
                    <AvaliableMoneyBox>
                      <SelectedAccountField>
                        Saldo Disponível:
                      </SelectedAccountField>
                      <SelectedAccountInfo>
                        {withdrawMoneyFormatted}
                      </SelectedAccountInfo>
                    </AvaliableMoneyBox>
                    <AvaliableInputBox>
                      <DashboardBLRInput
                        title={'Valor do Saque'}
                        name={'withdrawMoney'}
                        placeholder={'0,00'}
                        error={
                          useFormikProps.errors['withdrawMoney'] !==
                          undefined && useFormikProps.touched['withdrawMoney']
                        }
                        success={
                          useFormikProps.errors['withdrawMoney'] ===
                          undefined &&
                          useFormikProps.values['withdrawMoney'] !== ''
                        }
                        errorMsg={useFormikProps.errors['withdrawMoney']}
                        defaultValue={useFormikProps.values['withdrawMoney']}
                        onChange={(e: any) => {
                          if (e.target.value.length <= 14)
                            useFormikProps.setFieldValue(
                              'withdrawMoney',
                              e.target.value
                            )
                        }}
                        onBlur={useFormikProps.handleBlur}
                      />
                    </AvaliableInputBox>
                  </div>
                  <FirstStepButtonBox>
                    <DashboardhMediumButton
                      //@ts-ignore
                      type="submit"
                      background={
                        hasValueOfMoney ? getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR') : 'transparent'
                      }
                      color={hasValueOfMoney ? '#fff' : getDashColor('PRIMARY_BLUE_03', 'GRAY_DARK')}
                      height="52px"
                      maxWidth="100%"
                      variant={hasValueOfMoney ? 'contained' : 'outlined'}
                      borderRadius='100px'
                    >
                      {'Avançar'}
                      <Icon
                        width={24}
                        height={25}
                        iconName={'goForwardOutline'}
                        fill={hasValueOfMoney ? '#fff' : PRIMARY_BLUE_03}
                        classes="go-forward-chevron"
                      />
                    </DashboardhMediumButton>
                  </FirstStepButtonBox>
                </>
              )}
              {/* STEP - CONTA A TRANSFERIR*/}
              {currentStep === 2 && (
                <>
                  <StepTitleText>Dados para transferência</StepTitleText>
                  <InfoDivider />
                  {/* USUÁRIO TEM CONTAS */}
                  {filteredAccounts !== null && !useAccountForm && !usePixForm && (
                    <>
                      <DashboardAccountPicker
                        accountData={[
                          ...(filteredAccounts ?? []),
                          ...(pixAccounts ?? []),
                        ]}
                        setBankAccount={(account: any) =>
                          handlerSetBankAccount(account, useFormikProps)
                        }
                        selectedAccount={selectedAccount}
                        setSelectedAccount={setSelectedAccount}
                        isPix={true}
                      />
                      <AddAccountBox onClick={handleAddBankAccount}>
                        <AddAccountIconBox>
                          <Icon
                            width={window.innerWidth >= 762 ? 18 : 12}
                            height={window.innerWidth >= 762 ? 18 : 12}
                            iconName={'enterpriseOutline'}
                            fill={SECONDARY_GREEN_01}
                            classes="add-account-chevron"
                          />
                        </AddAccountIconBox>
                        <AddAccountTextBox>
                          <AddAccountTitle>
                            Adicionar nova conta bancária
                          </AddAccountTitle>
                          <AddAccountSub>
                            Preencha os dados com bastante atenção
                          </AddAccountSub>
                        </AddAccountTextBox>
                        <AddAccountArrowBox>
                          <Icon
                            width={10}
                            height={10}
                            iconName={'rightArrow'}
                            fill={'#000'}
                            classes="add-account-chevron"
                          />
                        </AddAccountArrowBox>
                      </AddAccountBox>

                      <AddPixAccountBox onClick={handleAddPixAccount}>
                        <IconPixContainer>
                          <PixIcon src={pixIcon} alt="icone de pix" />
                        </IconPixContainer>
                        <AddAccountTextBox>
                          <AddAccountTitle>Adicionar conta PIX</AddAccountTitle>
                          <AddAccountSub>
                            Preencha os dados com bastante atenção
                          </AddAccountSub>
                        </AddAccountTextBox>
                        <AddAccountArrowBox>
                          <Icon
                            width={10}
                            height={10}
                            iconName={'rightArrow'}
                            fill={'#000'}
                            classes="add-account-chevron"
                          />
                        </AddAccountArrowBox>
                      </AddPixAccountBox>
                    </>
                  )}
                  {/* USUÁRIO NÃO TEM CONTAS */}
                  {useAccountForm && !usePixForm && (
                    <GridForm>
                      <HorizontalContainer>
                        <RegistrationBox>
                          <FormikField
                            formikFieldType={'input'}
                            inputType={'text'}
                            name={'nationalRegistration'}
                            useFormik={useFormikProps}
                            title={'CPF/CNPJ'}
                            inputPlaceholder={'CPF ou CNPJ'}
                            maxLength={20}
                          />
                        </RegistrationBox>
                        <OwnerBox>
                          <FormikField
                            formikFieldType={'input'}
                            inputType={'text'}
                            name={'accountOwner'}
                            useFormik={useFormikProps}
                            title={'Titular/Razão Social'}
                            inputPlaceholder={'Titular da conta'}
                            maxLength={100}
                          />
                        </OwnerBox>
                      </HorizontalContainer>
                      <TransactionTypeBox>
                        <FormikField
                          formikFieldType={'dropdown'}
                          defaultValue={{
                            id: 0,
                            value: '',
                            label: 'Selecione o tipo de transação',
                          }}
                          dropdownOptions={transactionTypeOptions}
                          name={'transactionType'}
                          useFormik={useFormikProps}
                          title={'Tipo de transação'}
                        />
                      </TransactionTypeBox>

                      <BankBox>
                        <FormikField
                          formikFieldType={'dropdown'}
                          defaultValue={{
                            id: 0,
                            value: '0',
                            label: 'Selecione o Banco',
                          }}
                          dropdownOptions={bankListWithNumberAndName}
                          name={'bank'}
                          useFormik={useFormikProps}
                          title={'Banco'}
                        />
                      </BankBox>
                      <HorizontalContainer>
                        <AgencyBox>
                          <FormikField
                            formikFieldType={'input'}
                            inputType={'text'}
                            name={'agency'}
                            useFormik={useFormikProps}
                            title={'Agência'}
                            inputPlaceholder={'0000'}
                            maxLength={4}
                          />
                        </AgencyBox>
                        <AccountTypeBox>
                          <FormikField
                            formikFieldType={'dropdown'}
                            defaultValue={{
                              id: 0,
                              value: '0',
                              label: 'Selecione o tipo de conta',
                            }}
                            dropdownOptions={accountBaseData}
                            name={'accountType'}
                            useFormik={useFormikProps}
                            title={'Tipo de conta'}
                          />
                        </AccountTypeBox>
                      </HorizontalContainer>
                      <HorizontalContainer>
                        <AccountNumberBox>
                          <FormikField
                            formikFieldType={'input'}
                            inputType={'text'}
                            name={'accountNumber'}
                            useFormik={useFormikProps}
                            title={'Número da Conta'}
                            inputPlaceholder={'Número da conta'}
                            maxLength={20}
                          />
                        </AccountNumberBox>
                        <DigitBox>
                          <FormikField
                            formikFieldType={'input'}
                            inputType={'text'}
                            name={'accountDigit'}
                            useFormik={useFormikProps}
                            title={'Dígito'}
                            inputPlaceholder={'Digito da conta'}
                            maxLength={1}
                          />
                        </DigitBox>
                      </HorizontalContainer>
                      <AccountIdentifierBox>
                        <FormikField
                          formikFieldType={'input'}
                          inputType={'text'}
                          name={'accountIdentifier'}
                          useFormik={useFormikProps}
                          title={'Nome da conta'}
                          inputPlaceholder={'Escreva aqui o nome da conta'}
                          maxLength={100}
                        />
                      </AccountIdentifierBox>
                      <TermsAndConditionLabel>
                        <TermsAndConditionInput
                          type="checkbox"
                          name="saveAccount"
                          checked={saveAccount}
                          onChange={() => setSaveAccount(!saveAccount)}
                        />
                        <TermsAndConditionTextBox>
                          <TermsAndConditionText>
                            Salvar conta
                          </TermsAndConditionText>
                        </TermsAndConditionTextBox>
                      </TermsAndConditionLabel>
                      <CustomResumeModal
                        isOpen={isOpenResumeModal}
                        onRequestClose={() => setIsOpenResumeModal(false)}
                        nationalRegistration={formatCpfCnpj(
                          useFormikProps.values.nationalRegistration
                        )}
                        accountOwner={useFormikProps.values.accountOwner}
                        transactionType={useFormikProps.values.transactionType}
                        bank={getBankName(useFormikProps.values.bank, bankList)}
                        agency={useFormikProps.values.agency}
                        accountType={useFormikProps.values.accountType}
                        accountNumber={(
                          useFormikProps.values.accountNumber +
                          '-' +
                          useFormikProps.values.accountDigit
                        ).toUpperCase()}
                        saveButton={() => handleCustomResumeModalConfirm()}
                        isPix={false}
                      />
                    </GridForm>
                  )}
                  {usePixForm && (
                    <GridForm>
                      <HorizontalContainer>
                        <RegistrationPixBox>
                          <FormikField
                            formikFieldType={'input'}
                            inputType={'text'}
                            name={'nationalRegistration'}
                            useFormik={useFormikProps}
                            title={'CPF/CNPJ'}
                            inputPlaceholder={'CPF ou CNPJ'}
                            maxLength={20}
                          />
                        </RegistrationPixBox>
                        <OwnerPixBox>
                          <FormikField
                            formikFieldType={'input'}
                            inputType={'text'}
                            name={'accountOwner'}
                            useFormik={useFormikProps}
                            title={'Titular/Razão Social'}
                            inputPlaceholder={'Titular da conta'}
                            maxLength={100}
                          />
                        </OwnerPixBox>
                      </HorizontalContainer>
                      <TransactionTypeBox>
                        <FormikField
                          formikFieldType={'dropdown'}
                          defaultValue={{ id: 1, value: 'PIX', label: 'PIX' }}
                          dropdownOptions={transactionTypeOptions}
                          name={'transactionType'}
                          useFormik={useFormikProps}
                          title={'Tipo de transação'}
                        />
                      </TransactionTypeBox>
                      <HorizontalContainer>
                        <PixTypeKeyBox>
                          <FormikField
                            formikFieldType={'dropdown'}
                            defaultValue={{
                              id: 0,
                              value: '0',
                              label: 'Selecione o tipo da chave',
                            }}
                            dropdownOptions={pixKeyOptions}
                            name={'pixTypeKey'}
                            useFormik={useFormikProps}
                            title={'Tipo de chave PIX'}
                          />
                        </PixTypeKeyBox>
                        <PixKeyBox>
                          <FormikField
                            formikFieldType={'input'}
                            inputType={'text'}
                            name={'pixKey'}
                            useFormik={useFormikProps}
                            title={'Chave PIX'}
                            inputPlaceholder={'Digite sua chave PIX'}
                            maxLength={100}
                          />
                        </PixKeyBox>
                      </HorizontalContainer>
                      <TermsAndConditionLabel>
                        <TermsAndConditionInput
                          type="checkbox"
                          name="saveAccount"
                          checked={saveAccount}
                          onChange={() => setSaveAccount(!saveAccount)}
                        />
                        <TermsAndConditionTextBox>
                          <TermsAndConditionText>
                            Salvar conta
                          </TermsAndConditionText>
                        </TermsAndConditionTextBox>
                      </TermsAndConditionLabel>
                      <CustomResumeModal
                        isOpen={isOpenResumeModal}
                        onRequestClose={() => setIsOpenResumeModal(false)}
                        nationalRegistration={formatCpfCnpj(
                          useFormikProps.values.nationalRegistration
                        )}
                        accountOwner={useFormikProps.values.accountOwner}
                        transactionType={useFormikProps.values.transactionType}
                        pixKey={useFormikProps.values.pixKey}
                        saveButton={() => handleCustomResumeModalConfirm()}
                        isPix={true}
                        disabledButtons={loading}
                      />
                    </GridForm>
                  )}

                  <ButtonsGridBox>
                    <GoAHeadButtonBox>
                      <DashboardhMediumButton
                        //@ts-ignore
                        type={
                          !useAccountForm && !usePixForm ? 'submit' : 'button'
                        }
                        background={
                          (hasBankAccount || hasBankPixAccount) && !loading
                            ? getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR')
                            : GRAY_SCALE_09
                        }
                        color={
                          hasBankAccount || hasBankPixAccount
                            ? '#fff'
                            : PRIMARY_BLUE_03
                        }
                        height="50px"
                        width="100%"
                        maxWidth="438px"
                        variant={
                          (hasBankAccount || hasBankPixAccount) && !loading
                            ? 'contained'
                            : 'disabled'
                        }
                        onClick={() =>
                          useAccountForm || usePixForm
                            ? setIsOpenResumeModal(true)
                            : null
                        }
                        borderRadius="100px"
                      >
                        {!loading && (
                          <>
                            {'Avançar'}
                            <Icon
                              width={24}
                              height={25}
                              iconName={'goForwardOutline'}
                              fill={
                                hasBankAccount || hasBankPixAccount
                                  ? '#fff'
                                  : PRIMARY_BLUE_03
                              }
                              classes="go-forward-chevron"
                            />
                          </>
                        )}

                        {loading && <Loader small={true} />}
                      </DashboardhMediumButton>
                    </GoAHeadButtonBox>
                    <ReturnButtonBox>
                      <DashboardhMediumButton
                        onClick={handleAccountsBack}
                        //@ts-ignore
                        type="button"
                        background=""
                        color=""
                        height="52px"
                        maxWidth="100%"
                        variant={'outlined'}
                        borderRadius="100px"
                      >
                        {'Voltar'}
                      </DashboardhMediumButton>
                    </ReturnButtonBox>
                  </ButtonsGridBox>
                </>
              )}
              {currentStep === 3 && (
                <>
                  <div>
                    <StepTitleText>Resumo da Solicitação</StepTitleText>
                    <br />
                    <SelectedAccountInfoBox>
                      {useFormikProps.values.transactionType === 'PIX' ? (
                        <>
                          <SelectedAccountBox>
                            <SelectedAccountField>Valor</SelectedAccountField>
                            <SelectedAccountInfo>
                              {formatReal(useFormikProps.values.withdrawMoney)}
                            </SelectedAccountInfo>
                          </SelectedAccountBox>
                          <InfoDivider />
                          <SelectedAccountBox>
                            <SelectedAccountField>Taxa</SelectedAccountField>
                            <SelectedAccountInfo>R$ 0,00</SelectedAccountInfo>
                          </SelectedAccountBox>
                          <InfoDivider />
                          <SelectedAccountBox>
                            <SelectedAccountField>
                              CPF/CNPJ
                            </SelectedAccountField>
                            <SelectedAccountInfo>
                              {formatCpfCnpj(
                                useFormikProps.values.nationalRegistration
                              )}
                            </SelectedAccountInfo>
                          </SelectedAccountBox>
                          <InfoDivider />
                          <SelectedAccountBox>
                            <SelectedAccountField>Titular</SelectedAccountField>
                            <SelectedAccountInfo>
                              {useFormikProps.values.accountOwner}
                            </SelectedAccountInfo>
                          </SelectedAccountBox>
                          <InfoDivider />
                          <SelectedAccountBox>
                            <SelectedAccountField>
                              Tipo de transação
                            </SelectedAccountField>
                            <SelectedAccountInfo>
                              {useFormikProps.values.transactionType}
                            </SelectedAccountInfo>
                          </SelectedAccountBox>
                          <InfoDivider />
                          <SelectedAccountBox>
                            <SelectedAccountField>
                              Tipo de Chave PIX
                            </SelectedAccountField>
                            <SelectedAccountInfo>
                              {useFormikProps.values.pixTypeKey}
                            </SelectedAccountInfo>
                          </SelectedAccountBox>
                          <InfoDivider />
                          <SelectedAccountBox>
                            <SelectedAccountField>
                              Chave PIX
                            </SelectedAccountField>
                            <SelectedAccountInfo>
                              {useFormikProps.values.pixKey}
                            </SelectedAccountInfo>
                          </SelectedAccountBox>
                        </>
                      ) : (
                        /* 🔥 Se for uma conta bancária normal, mostra os dados do banco */
                        <>
                          <SelectedAccountBox>
                            <SelectedAccountField>Valor</SelectedAccountField>
                            <SelectedAccountInfo>
                              {formatReal(useFormikProps.values.withdrawMoney)}
                            </SelectedAccountInfo>
                          </SelectedAccountBox>
                          <InfoDivider />
                          <SelectedAccountBox>
                            <SelectedAccountField>
                              CPF/CNPJ
                            </SelectedAccountField>
                            <SelectedAccountInfo>
                              {formatCpfCnpj(
                                useFormikProps.values.nationalRegistration
                              )}
                            </SelectedAccountInfo>
                          </SelectedAccountBox>
                          <InfoDivider />
                          <SelectedAccountBox>
                            <SelectedAccountField>Titular</SelectedAccountField>
                            <SelectedAccountInfo>
                              {useFormikProps.values.accountOwner}
                            </SelectedAccountInfo>
                          </SelectedAccountBox>
                          <InfoDivider />
                          <SelectedAccountBox>
                            <SelectedAccountField>Banco</SelectedAccountField>
                            <SelectedAccountInfo>
                              {getBankName(
                                useFormikProps.values.bank,
                                bankList
                              )}
                            </SelectedAccountInfo>
                          </SelectedAccountBox>
                          <InfoDivider />
                          <SelectedAccountBox>
                            <SelectedAccountField>Agência</SelectedAccountField>
                            <SelectedAccountInfo>
                              {useFormikProps.values.agency}
                            </SelectedAccountInfo>
                          </SelectedAccountBox>
                          <InfoDivider />
                          <SelectedAccountBox>
                            <SelectedAccountField>Conta</SelectedAccountField>
                            <SelectedAccountInfo>
                              {(
                                useFormikProps.values.accountNumber +
                                '-' +
                                useFormikProps.values.accountDigit
                              ).toUpperCase()}
                            </SelectedAccountInfo>
                          </SelectedAccountBox>
                        </>
                      )}

                      <br />
                      <ReasonAndDescriptionBox>
                        <DescriptionBox>
                          <FormikField
                            formikFieldType={'input'}
                            inputType={'text'}
                            name={'description'}
                            useFormik={useFormikProps}
                            title={'Descrição'}
                            inputPlaceholder={'Descrição'}
                            maxLength={50}
                          />
                        </DescriptionBox>
                      </ReasonAndDescriptionBox>
                      <SelectedAccountBox>
                        <TermsAndConditionLabel>
                          <TermsAndConditionInput
                            type="checkbox"
                            name="termsAndConditions"
                            checked={useFormikProps.values.termsAndConditions}
                            onChange={useFormikProps.handleChange}
                          />
                          <TermsAndConditionTextBox>
                            <TermsAndConditionText>
                              Li e aceito os{' '}
                              <TermsAndConditionLink
                                onClick={() => setIsTermModal(true)}
                              >
                                {' '}
                                termos e condições{' '}
                              </TermsAndConditionLink>{' '}
                              da solicitação de saque.{' '}
                            </TermsAndConditionText>
                          </TermsAndConditionTextBox>
                        </TermsAndConditionLabel>
                      </SelectedAccountBox>
                    </SelectedAccountInfoBox>
                  </div>
                  <ButtonsGridBox>
                    <GoAHeadButtonBox>
                      <DashboardhMediumButton
                        //@ts-ignore
                        type="submit"
                        background={
                          hasTermsAndCondition
                            ? SECONDARY_GREEN_07
                            : GRAY_SCALE_09
                        }
                        color={hasTermsAndCondition ? '#fff' : PRIMARY_BLUE_03}
                        height="50px"
                        width="100%"
                        maxWidth="438px"
                        variant={
                          hasTermsAndCondition ? 'contained' : 'disabled'
                        }
                        borderRadius='100px'
                      >
                        {'Confirmar Saque'}
                      </DashboardhMediumButton>
                    </GoAHeadButtonBox>
                    <ReturnButtonBox>
                      <DashboardhMediumButton
                        onClick={handleBack}
                        //@ts-ignore
                        type="button"
                        background=""
                        color=""
                        height="50px"
                        maxWidth="100%"
                        variant={'outlined'}
                        borderRadius='100px'
                      >
                        {'Voltar'}
                      </DashboardhMediumButton>
                    </ReturnButtonBox>
                  </ButtonsGridBox>
                </>
              )}
            </StyledForm>
          </>
        )}
        {balanceDistribution.isLoading && (
          <ExceptionContainer height={400} margin={false}>
            <Loader />
          </ExceptionContainer>
        )}
        <ConfirmationModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          setCode={setCode2fa}
          setIsSuccess={setIsSuccess}
          setConfirmationMsg={setConfirmationMsg}
          setIsConfirmationOpen={setIsConfirmationOpen}
          submitResponse={withdrawTrigger}
        />

        <SucessOrFailModal
          isOpen={isConfirmationOpen}
          isSuccess={isSuccess}
          goNPS={{
            show: HasNPS,
            object: NPSLoading,
          }}
          customSuccess={confirmationMsg.customSuccess}
          customError={confirmationMsg.customError}
          setIsOpen={setIsConfirmationOpen}
          rollBackUrl={rollBackUrl}
        />
        <NPSModal
          user={user as any}
          event={{
            id: id!,
            event_name: eventoData.event_name,
            pracaId: eventoData.pracaId,
            praca: eventoData.praca,
          }}
          service={NPSService}
          isOpen={NPSLoading.value}
          onRequestClose={() => {
            NPSLoading.onFalse()
            window.location.href = rollBackUrl
          }}
        />
        <CustomModal isOpen={isTermModal}>
          <UseTerms setIsOpen={setIsTermModal} />
        </CustomModal>
        <PixConfirmationModal
          isOpen={isPixConfirmationModalOpen}
          onRequestClose={() => setIsPixConfirmationModalOpen(false)}
          onConfirm={() => {
            setIsPixConfirmationModalOpen(false)
            setIsOpen(true)
          }}
          pixKey={useFormikProps.values.pixKey}
          value={formatReal(useFormikProps.values.withdrawMoney)}
          owner={useFormikProps.values.accountOwner}
        />
        <TedConfirmationModal
          isOpen={isTedConfirmationModalOpen}
          onRequestClose={() => setIsTedConfirmationModalOpen(false)}
          onConfirm={() => {
            setIsTedConfirmationModalOpen(false)
            setIsOpen(true)
          }}
          value={formatReal(useFormikProps.values.withdrawMoney)}
          owner={useFormikProps.values.accountOwner}
          tedTax={formatReal((eventData?.event?.taxaSaqueTED || 0).toString())}
          receivingValue={formatReal(
            (
              parseFloat(
                useFormikProps.values.withdrawMoney.replace(',', '.')
              ) - (eventData?.event?.taxaSaqueTED || 0)
            ).toString()
          )}
        />
      </Container>
    </>
  )
}
